import { render } from "./AdminLongTimeNoSeeView.vue?vue&type=template&id=793daa0a&scoped=true"
import script from "./AdminLongTimeNoSeeView.vue?vue&type=script&lang=js"
export * from "./AdminLongTimeNoSeeView.vue?vue&type=script&lang=js"

import "./AdminLongTimeNoSeeView.vue?vue&type=style&index=0&id=793daa0a&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793daa0a"]])

export default __exports__